import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/commissions";

const getCommissions = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const createCommission = async (commission: any) => {
  try {
    // Convert value to number before sending
    const commissionPayload = {
      ...commission,
      value: parseFloat(commission.value),
    };

    const response = await axios.post(API_URL, commissionPayload);
    if (response.status === 201) {
      return {
        success: true,
        message: "Commission rule created successfully",
      };
    }
  } catch (error) {
    console.log("create commission error " + error);
    return { success: false, message: handleError(error) };
  }
};

const updateCommission = async (id: number, commission: any) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, commission);
    if (response.status === 200) {
      return {
        success: true,
        message: "Commission updated successfully",
      };
    }
  } catch (error) {
    return { success: false, message: handleError(error) };
  }
};

const deleteCommission = async (id: number) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    if (response.status === 200) {
      return {
        success: true,
        message: "Commission deleted successfully",
      };
    }
  } catch (error) {
    return { success: false, message: handleError(error) };
  }
};

const handleError = (error: any) => {
  if (axios.isAxiosError(error)) {
    if (!error.response) {
      return "Network error. Please check your internet connection.";
    } else {
      return `Error: ${error.response.status} - ${error.response.data}`;
    }
  } else {
    return "An unexpected error occurred:";
  }
};

export { getCommissions, createCommission, updateCommission, deleteCommission };
